import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  holiday: Boundaries["removeHoliday"]["request"],
): State {
  const index = state.findIndex((req) => req.holiday.uuid === holiday.uuid);
  return index !== -1
    ? [
        ...state.slice(0, index),
        { holiday, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { holiday, request: setRequestStateToPending() }];
}
function handleSuccess(
  state: State,
  holiday: Boundaries["removeHoliday"]["success"],
): State {
  const index = state.findIndex((req) => req.holiday.uuid === holiday.uuid);
  return index !== -1
    ? [
        ...state.slice(0, index),
        { holiday, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { holiday, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  holiday: Boundaries["removeHoliday"]["failure"],
): State {
  const index = state.findIndex((req) => req.holiday.uuid === holiday.uuid);
  return index !== -1
    ? [
        ...state.slice(0, index),
        { holiday, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { holiday, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeHolidayRequested]: handleRequest,
    [events.removeHolidaySucceeded]: handleSuccess,
    [events.removeHolidayFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
